export default "__VITE_ASSET__DHa1Pqr2__"